import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CLUB_COUNTRIES } from "../../constants/countries";
import { currentAppLanguage } from "../../utils/appLanguages";
import { submitClubInquiry } from "../../api/clubInquiryApi";

const PILOT_FIRST = ["LU", "BE", "FR"];
const ROLES = ["president", "coach", "admin", "federation", "parent", "other"];

function countryOptions() {
  const first = PILOT_FIRST.map((code) => CLUB_COUNTRIES.find((c) => c.code === code)).filter(Boolean);
  const rest = CLUB_COUNTRIES.filter((c) => !PILOT_FIRST.includes(c.code));
  return [...first, ...rest];
}

export function PilotInquiryForm() {
  const { t, i18n } = useTranslation();
  const [clubName, setClubName] = useState("");
  const [country, setCountry] = useState("LU");
  const [role, setRole] = useState("president");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await submitClubInquiry({
        club_name: clubName,
        country,
        role,
        email,
        note,
        lang: currentAppLanguage(i18n),
      });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || err.message || t("mhFormError"));
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <p className="mh-form__thanks" role="status">
        {t("mhFormThanks")}
      </p>
    );
  }

  return (
    <form className="mh-form" onSubmit={handleSubmit} noValidate>
      <div className="mh-form__row">
        <label>
          {t("mhFormClub")}
          <input
            type="text"
            name="club_name"
            autoComplete="organization"
            required
            minLength={2}
            value={clubName}
            onChange={(e) => setClubName(e.target.value)}
          />
        </label>
        <label>
          {t("mhFormCountry")}
          <select name="country" value={country} onChange={(e) => setCountry(e.target.value)} required>
            {countryOptions().map((c) => (
              <option key={c.code} value={c.code}>
                {c.name}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="mh-form__row">
        <label>
          {t("mhFormRole")}
          <select name="role" value={role} onChange={(e) => setRole(e.target.value)} required>
            {ROLES.map((id) => (
              <option key={id} value={id}>
                {t(`mhFormRole_${id}`)}
              </option>
            ))}
          </select>
        </label>
        <label>
          {t("mhFormEmail")}
          <input
            type="email"
            name="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
      </div>
      <label>
        {t("mhFormNote")}
        <textarea
          name="note"
          rows={4}
          maxLength={2000}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </label>
      {error ? (
        <p className="mh-form__error" role="alert">
          {error}
        </p>
      ) : null}
      <button type="submit" className="mh-btn mh-btn--primary" disabled={submitting}>
        {submitting ? t("mhFormSending") : t("mhRequestPilot")}
      </button>
    </form>
  );
}
